<template>
  <fieldset class="volume-variant volume-variant1">
    <legend class="is-sr-only" id="legend-volume">{{ legendName }}</legend>
    <div class="productItemActiveId">{{ sfccvolumesdetails[0].ean }}</div>
    <div class="volume-variant__wrapper" v-if="volumes.length > 1">

      <div
        class="select-custom"
        v-clickoutside="DropdownClose">

        <button
          class="select-custom__btn"
          :class="{
            'is-active': isDropdownOpened
          }"
          id="current-volume"
          :aria-labelby="a11yAriaLabel"
          :aria-expanded="isDropdownOpened ? 'true' : 'false'"
          @click.prevent="dropdownToggle()"
          @blur="dropdownOnBlur()"
          ref="dropdownBtn">
          <span>{{ activeVolume }}</span>
          <svg width="16" height="8" aria-hidden="true">
            <path fill-rule="nonzero" d="M14.675.62l.65.76L8 7.659.675 1.379l.65-.759L8 6.341z"/>
          </svg>
        </button>

        <transition name="main-menu-languages">
          <ul
            @change="getChecked"
            v-show="isDropdownOpened"
            @keyup.esc="dropdownToggle()">
            <li v-for="(item,index) in volumes" :key="item.id">
              <input
                type="radio"
                name="volume"
                :id="item.id"
                :value="item.size"
                class="js-select-option"
                v-model="activeVolume"
                @blur="dropdownOnBlur()"
                @change="selectedSize(item.variantEANId), selectedVariant(item.variantEANId)"
                @click="buynowOnChange(), getsfccPrice(), emptyInventory()"
              >
              <label
                :for="item.id"
                @click="DropdownClose()"
                class="volume-variant__label"
                :key="index">
                {{ item.size }}
              </label>
            </li>
          </ul>
        </transition>
      </div>

    </div>
    <p v-else class="volume-variant__single-el">{{ volumes[0].size }}
      <ul style="display:none">
        <li v-for="item in volumes" :key="item.id">
          <input
            type="radio"
            name="volume"
            checked
            class="js-select-option"
            :id="item.id"
          >
        </li>
      </ul>
    </p>
  </fieldset>
</template>
<script>
  import { AnalyticsHandler } from '@Foundation/analyticsHandler';
  import { clickoutside } from '@Foundation/directives/clickoutside/clickoutside';
  import { mapActions } from 'vuex';

  export default {
    name: 'volume-variant',
    directives: {
      clickoutside,
    },
    props: {
      volumes: { type: Array, required: true },
      legendName: { type: String, required: true, default: 'Volume' },
      a11yAriaLabel: { type: String, required: false, default: 'legend-volume current-volume' },
      sfccvolumesdetails: { type: Array, required: true }
    },

    data() {
      return {
        isDropdownOpened: false,
        activeVolumeIndex: 0,
        activeVolume: this.volumes[0].size,
        activeVolumeId: this.volumes[0].id
      };
    },

    watch: {
      activeVolume() {
        this.announceVolumeSelection();
      }
    },

    mounted() {
      window.eventBus.$emit('SelectVarientPdpChangedAction', this.volumes[0].variantEANId);
      this.dropdownOnBlur();
      this.announceVolumeSelection();
      this.getsfccPrice();
    },

    methods: {
      selectedVariant(variant){
       window.eventBus.$emit('selectedVarientSize', variant);
      },
      selectedSize(variant){
       window.eventBus.$emit('SelectVarientPdpChangedAction', variant);
       
      },
      DropdownClose() {
        /* istanbul ignore else */
        if (this.isDropdownOpened) {
          this.isDropdownOpened = false;
        }
      },

      dropdownToggle() {
        if (!this.isDropdownOpened) {
          setTimeout(() => {
            this.isDropdownOpened = true;
            setTimeout(() => {
              /* istanbul ignore else */
              if (this.$el.querySelector('input[type="radio"]:checked')) {
                this.$el.querySelector('input[type="radio"]:checked').focus();
              }
            }, 50);
          }, 100);
        } else {
          this.DropdownClose();
        }
      },

      dropdownOnBlur() {
        setTimeout(() => {
          let activeElementClass;

          /* istanbul ignore next */
          if (document.documentMode || /Edge/.test(navigator.userAgent)) {
            /* eslint-disable prefer-destructuring */
            activeElementClass = document.activeElement.classList[0] || null;
          } else {
            activeElementClass = document.activeElement.classList.value;
          }
          /* istanbul ignore else */
          if (!(activeElementClass === 'js-select-option') && this.isDropdownOpened === true) {
            this.DropdownClose();
          }
        }, 300);
      },

      buynowOnChange() {
        setTimeout(() => {
          var buynowToggler = document.getElementsByClassName('popupContainer__bagIcon')[0];
          if (undefined !== buynowToggler) {
           window.eventBus.$on('clickandcollectEnabled', payload => {
          if(payload != true){
           buynowToggler.click();
          }
           });
          }
        }, 300);
      },

      getChecked() {
        const inputs = this.$el.querySelectorAll('input[type="radio"]');
        for (let i = 0; i < inputs.length; ++i) {
          /* istanbul ignore else */
          if (inputs[i].checked) {
            this.activeVolumeIndex = i;
            this.activeVolumeId = this.volumes[i].id;
            this.setAnalytics(this.volumes[i].tagging);
          }
        }
      },
      getsfccPrice: function() {
        setTimeout(() => {
          var sfccPriceRowExist = document.getElementById('sfccPrice');
          if (sfccPriceRowExist) {
            var inputData = this.$el.querySelector('input[type="radio"]:checked').id;
            for (let i = 0; i < this.sfccvolumesdetails.length; ++i) {
              var JsonDataID = this.sfccvolumesdetails[i].id;
              if (JsonDataID === inputData) {
                var dataSfccPrice = this.sfccvolumesdetails[i].sfccPrice;
                var dataSfccEAN = this.sfccvolumesdetails[i].ean;
                var sfccPriceRow = document.getElementById('sfccPrice');
                var sfccEANRow = document.getElementsByClassName('productItemActiveId')[0];
                if (sfccPriceRow) {
                  sfccPriceRow.innerHTML = dataSfccPrice;
                  var afterPay = document.getElementsByTagName('afterpay-placement')[0];
                  if (afterPay) {
                    afterPay.setAttribute('data-amount', dataSfccPrice);
                  }
                }
                if (sfccEANRow) {
                  sfccEANRow.innerHTML = dataSfccEAN;
                }
              }
            }
          }
        },200);
      },

      /* This function is to pass the API url */
      getData: function(url) {
        return fetch(url).then(response => response.json());
      },

      /* This function is to pass the API url --ends here */

      /* This function is to check empty inventory on variant change */
      emptyInventory: function () {
        document.getElementById('addtocartComponentLoader').classList.add('active');
        setTimeout(() => {
          var emptyProductItemIdActive;
          var emptyisColorVariantExist = document.getElementsByClassName('color-variant');
          if (emptyisColorVariantExist.length > 0) {
            emptyProductItemIdActive = document.getElementsByClassName('productItemActiveId')[1].innerHTML;
          } else {
            emptyProductItemIdActive = document.getElementsByClassName('productItemActiveId')[0].innerHTML;
          }
          this.getData(`/api/connector/productexistsininventory?productid=${emptyProductItemIdActive}`)
            .then(jsonData => {
              if (!(jsonData.orderable)) {
                document.getElementById('addtocartComponent').classList.add('disabledComponent');
              } else {
                var addtocartComponentData = document.getElementById('addtocartComponent');
                var priceContent = document.getElementById('sfccPrice');
                if (priceContent.innerHTML  !== '') {
                  addtocartComponentData.classList.remove('disabledComponent');
                  this.isMaxInventory();
                } else {
                  addtocartComponentData.classList.add('disabledComponent');
                }
              }
              document.getElementById('addtocartComponentLoader').classList.remove('active');
            });
        }, 300);
      },

      /* This function is to check empty inventory on variant change --ends here */

      /* This function is to check max inventory on variant change */
      isMaxInventory: function () {
        var emptyProductItemIdActive;
        var emptyisColorVariantExist = document.getElementsByClassName('color-variant');
        if (emptyisColorVariantExist.length > 0) {
          emptyProductItemIdActive = document.getElementsByClassName('productItemActiveId')[1].innerHTML;
        } else {
          emptyProductItemIdActive = document.getElementsByClassName('productItemActiveId')[0].innerHTML;
        }
        var ProductItemID = document.getElementsByClassName('productCart__item_ID');
        for (var i = 0; i < ProductItemID.length; i++) {
          var activeData = ProductItemID[i].textContent;
          if (emptyProductItemIdActive === activeData) {
            var theSelectData = document.getElementsByClassName('productCart__itemQuantitySelect')[i];
            var lastValue = theSelectData.options[theSelectData.options.length - 1].value;
            var selectedText = theSelectData.options[theSelectData.selectedIndex].value;
            if (selectedText >= lastValue) {
              document.getElementById('addtocartComponent').classList.add('disabledComponent');
            } else {
              document.getElementById('addtocartComponent').classList.remove('disabledComponent');
            }
          }
        }
      },

      /* This function is to check max inventory on variant change --ends here */

      setAnalytics(tagging) {
        AnalyticsHandler.pushDataLayer(tagging);
      },

      announceVolumeSelection() {
        const selectedColorData = {
          name: this.volumes[this.activeVolumeIndex].size,
          imgUrl: this.volumes[this.activeVolumeIndex].img,
        };
        this.selectPreferredProductVariant(selectedColorData);
      },
      ...mapActions(['selectPreferredProductVariant'])
    },
  };
</script>
<style lang='scss' src="./volume-variant.scss"></style>